<template>
  <div class="container">
    <div>
      <div class="limit_title">额度查询</div>
      <div class="limit_container">
        <div class="overall_limit">
          <div class="hint_mes">
            <img src="" alt="">
            <span>授信总额度（元）</span>
          </div>
          <span class="money">10,000.00</span>
          <div class="botto">xxx</div>
        </div>

        <div class="other_limit">
          <div class="used_limit">
            <span class="left">已用额度</span>
            <i class="cubeic-arrow"></i>
            <span class="right">2,515.00</span>
          </div>
          <div class="usable_limit">
            <span class="left">可用额度</span>
            <span class="right">8,755.00</span>
          </div>
          
        </div>
      </div>
    </div>
    <!-- <div class="prompt">
      <div class="prompt_title">
          <span class="prompt_title_sub">额度查询</span>
      </div>
    </div>

    <div class="white_line"></div>

    <div class="content_info">
      <div class="limit">
        <div class="limit_up">授信总额度（元）</div>
        <div class="limit_down">10000.00</div>
        <div class="limit_right">100</div>
      </div>

    </div>

    <div class="white_line"></div>

    <div class="content_info">
      <div class="limit">
        <div class="limit_spand">
          <span class="limit_size_left">已用额度</span>
          <span class="limit_size_middle">2515.00</span>
          <i class="cubeic-arrow"></i>
        </div>
        <span class="limit_line"></span>
        <div class="limit_usable">
          <div class="limit_size_left">可用额度</div>
          <div class="limit_size_middle">8755.00</div>
          <div class="limit_size_right"></div>
        </div>
      </div>
    </div> -->

  </div> 
</template>

<script>
import { axios } from '../../util/request'
import { log } from 'util'
export default {
  data(){
    return{

    }
  },
  // methods:{

  // }
}
</script>

<style lang="less" scoped>
@import '../../assets/styles/varibles.less';
.container {
  padding-top: 2px;
  background-color: #fff;
}
.limit_title{
  width: calc(100%);
  height : 3rem;
  line-height: 3rem;
  text-align: left;
  text-indent: 22px;
  color: #fff;
  font-size: 1.125rem;
  // background-color : #EFEFEF;
  background-color: @titleColor;
}
.limit_container {
  padding-top: 12px;
  .overall_limit {
    height: 91.5px;
    width: 353px;
    background-color: #efefef;
    border-radius: 8px;
    margin: 0 auto;
    padding: 11px 20px 19px 17px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    .hint_mes {
      text-align: left;
      color: #626262;
      font-size: 15px;
      margin-bottom: 19px;
    }
    .money {
      font-size: 25px;
      color: #fc5e03;
    }
    .botto {
      position: absolute;
      bottom: 19px;
      right: 20px;
    }
  }
  .other_limit {
    height: 101px;
    width: 353px;
    padding: 5px;
    background-color: #efefef;
    border-radius: 8px;
    margin: 0 auto;
    box-sizing: border-box;
    .used_limit {
      height: 45px;
      width: 100%;
      line-height: 45px;
      border-bottom: 1px solid #fff;
      box-sizing: border-box;
      font-size: 15px;
      color: #626262;
      .left {
        float: left;
        margin-left: 19px;
      }
      .right {
        float: right;
        margin-right: 18px;
      }
      .cubeic-arrow::before {
        float: right;
        margin-right: 13px;
      }
    }
    .usable_limit {
      height: 45px;
      width: 100%;
      line-height: 45px;
      font-size: 15px;
      color: #626262;
      .left {
        float: left;
        margin-left: 19px;
      }
      .right {
        float: right;
        margin-right: 45px;
      }
    }
  }
}

// .prompt_title{
//   width: calc(100%);
//   height : 1rem;
// }
// .prompt_title_sub{
//     width: calc(100%);
//     height : 1rem;
//     // color: #494949;
//     color: #fff;
//     font-weight: 500;
//     line-height : 1rem;
//     display : block;
//     margin : 0rem 0 1rem 0;
//     padding : 1rem 0 1rem 0;
//     text-align : left ;
//     text-indent : 1rem;
//     font-size: 0.94rem;
// }
// .white_line{
//   background-color: #FFFFFF;
//   height: 1rem;
//   width: 100%;
// }
// .content_info{
//   height: 5rem;
//   width: 100%;
//   background-color: #FFFFFF;
// }
// .limit{
//   background-color: #EFEFEF;
//   height: 5rem;
//   width: 92%;
//   margin: auto;
//   padding: 0px 0px 0px 0px;
// }
// .limit_up{
// text-align: left;
// padding: 11px 20px;
// }
// .limit_down{
// width: 80%;
// color: #FB5C02;
// display: inline-block;
// padding: 0px 0px;
// font-size: xx-large;
// }
// .limit_right{
// width: 10%;
// display: inline-block;
// color: #FB5C02;
// padding: 0px 0px;
// }
// .limit_line{
// display: inline-block;
// height: 1px;
// width: 90%;
// background: #FFFFFF;
// overflow: hidden;
// vertical-align: middle;
// margin: inherit;
// }
// .limit_spand{
// padding: 8px 0px 0px 0px;
// }
// .limit_usable{
// padding: 0px 0px 0px 0px;
// }
// .limit_size_left{
//   display: inline-block;
//   text-align: left;
//   width: 30%;
//   padding: 8px 0px 0px 0px;
// }
// .limit_size_middle{
//   display: inline-block;
//   text-align: right;
//   width: 50%;
//   padding: 8px 0px 0px 0px;
// }
// .limit_size_right{
//   display: inline-block;
//   text-align: center;
//   width: 10%;
//   padding: 8px 0px 0px 0px;
// }
          
</style>
